<template>
  <div class="PermanentPointsView">
    <aside class="PermanentPointsView__panel">
      <section class="PermanentPointsView__section">
        <h1 class="title is-5">Punkty stałe</h1>

        <b-message v-if="loadError" type="is-danger" size="is-small">
          {{ loadError }}
        </b-message>
        <b-message v-if="successMessage" type="is-success" size="is-small">
          {{ successMessage }}
        </b-message>
        <b-message v-if="conflictMessage" type="is-warning" size="is-small">
          {{ conflictMessage }}
        </b-message>
      </section>

      <section class="PermanentPointsView__section">

        <!-- <b-field grouped class="level-right search-field">
          <div class="control is-clearfix">
            <input
                placeholder="Imię nazwisko, tel, NR zam."
                type="search"
                class="input"
                v-model="searchText"
                @keyup.enter="search(searchText)"
                @input="checkIsSearchReseted"
            />
          </div>
          <p class="control">
            <button class="button is-primary" @click="search(searchText)">Szukaj</button>
          </p>
        </b-field> -->

        <permanent-points-table
            @permanent-point-click="$emit('permanent-point-click', $event)"
        />

      </section>

      <Footer />
    </aside>

    <div class="PlanRouteView__map">
      <Map />
    </div>
  </div>
</template>

<script>
import bus from '@/EventBus'
import config from '@/config'
import { mapState } from 'vuex'
import Map from '@/components/Map'
import SelectedRoutePoints from '@/components/planning/SelectedRoutePoints'
import PlanRouteForm from '@/components/planning/PlanRouteForm'
import OrderService from '@/services/OrderService'
import PermanentPointService from '@/services/PermanentPointService'
import RouteService from '@/services/RouteService'
import UserService from '@/services/UserService'
import {
  normalizeOrder,
  normalizePermanentPoint,
  normalizeCollection,
  pointToPlanPayload
} from '@/adapters/MapPointAdapter'
import {DEFAULT_ROUTE_COLOR} from '@/configs/routeColors'
import Footer from "../Footer.vue";
import UsersTable from "../tables/UsersTable.vue";
import PermanentPointsTable from "../tables/PermanentPointsTable.vue";


export default {
  name: 'PlanRouteView',
  components: {
    PermanentPointsTable,
    Footer,
    Map
  },
  computed: {
    config() {
      return config.company
    }
  },
  data() {
    return {
      permanentPoints: [],
      users: [],
      selectedPoints: [],
      isOrdersLoading: false,
      isPermanentPointsLoading: false,
      isUsersLoading: false,
      isSaving: false,
      loadError: '',
      formError: '',
      successMessage: '',
      conflictMessage: '',
      conflicts: [],
      validationErrors: [],
      searchText: ''
    }
  },
  methods : {
    search() {
      this.$store.dispatch('permanentPoint/search', this.searchText)
    },
    checkIsSearchReseted() {
      if (this.searchText === '') this.$store.dispatch('permanentPoint/search', this.searchText)
    },
  }
}
</script>

<style lang="scss" scoped>
.PermanentPointsView {
  display: grid;
  grid-template-columns: minmax(360px, 40%) minmax(0, 1fr);
  height: 100%;
  min-height: 0;
  @media (max-width: 1100px) {
    display: flex;
    flex-direction: column;
    overflow: auto;
  }

  &__map {
    min-height: 0;
    border-left: 3px solid green;
    background-color: rgb(223, 153, 153);
    @media (max-width: 1100px) {
      height: 520px;
      min-height: 520px;
    }
  }

  &__panel {
    overflow: auto;
    background: #fff;
    padding: 12px;
  }

  &__section {
    margin-bottom: 18px;
  }

  &__tabs {
    margin-bottom: 12px;

    ul {
      flex-wrap: wrap;
    }

    a {
      padding: 7px 10px;
      font-size: 13px;
    }
  }

  &__stats {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-bottom: 12px;
  }

  &__loaders {
    display: grid;
    gap: 4px;
    color: #777;
    font-size: 12px;
  }

  &__clear {
    margin-top: 10px;
  }

  &__missing {
    margin-left: 0;
    list-style: none;
    font-size: 12px;

    li {
      padding: 4px 0;
      border-bottom: 1px solid #eee;
    }

    small {
      display: block;
      color: #777;
    }
  }
}
</style>
